import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "./components/ui/sonner";
import { I18nProvider } from "./i18n";
import { AuthProvider, useAuth } from "./lib/auth";
import { ThemeProvider, SettingsProvider } from "./lib/providers";
import { SiteApplier } from "./lib/SiteApplier";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Layout";
import Home from "./pages/Home";
import Help from "./pages/Help";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";

const Protected = ({ admin, children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="flex h-[60vh] items-center justify-center"><Loader2 className="h-6 w-6 animate-spin" style={{ color: "var(--gold)" }} /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (!admin && user.role === "admin") return <Navigate to="/admin" replace />;
  return children;
};

function App() {
  return (
    <ThemeProvider>
      <SettingsProvider>
        <I18nProvider>
          <AuthProvider>
            <BrowserRouter>
              <SiteApplier />
              <div className="flex min-h-screen flex-col">
                <Navbar />
                <main className="flex-1">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/help" element={<Help />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
                    <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </main>
                <Footer />
              </div>
              <Toaster richColors position="top-right" />
            </BrowserRouter>
          </AuthProvider>
        </I18nProvider>
      </SettingsProvider>
    </ThemeProvider>
  );
}

export default App;
